import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-list-item',
	templateUrl: './list-item.component.html',
	styleUrls: ['./list-item.component.scss'],
	/** Removed View encapsulation to allow for CSS counter use for ordered items */
	encapsulation: ViewEncapsulation.None,
})
export class ListItemComponent {
	@Input() public readonly itemNumber?: number | null;
	@Input() public readonly heading: string | null = null;
	@HostBinding('class.c-list__item') readonly klassName: boolean = true;
	@HostBinding('attr.role') readonly role: string = `list-item`;

	constructor() { }
}
